import { useEffect, useState } from 'react';
import {
  isHistoryFeatureEnabled,
  requestHistoryFromParent,
} from '../utils/historyFeatureFlag';

/**
 * History preview flag — enabled when iframe URL, parent postMessage, or
 * localStorage override (fusion_history_preview=1) says so.
 */
export function useHistoryFeatureFlag() {
  const [enabled, setEnabled] = useState(() => isHistoryFeatureEnabled());

  useEffect(() => {
    if (enabled) return undefined;
    return requestHistoryFromParent((fromParent) => {
      if (fromParent) setEnabled(true);
    });
  }, [enabled]);

  return enabled;
}
